import { TextFieldConfig, tokens, media, css } from '@sail/ui';
export const textFieldCustomization = TextFieldConfig.customize({
    uses: [
        css({
            gridTemplateColumns: '1fr',
            columnGap: `${tokens.space.large}`,
            rowGap: `0`,
            [media.up(tokens.viewport.small)]: {
                gridTemplateColumns: '160px 1fr',
                gridTemplateRows: 'repeat(auto-fit)',
                gapY: '0'
            }
        })
    ],
    subviews: {
        inputs: {
            uses: [
                css({
                    gridRow: 'auto',
                    [media.up(tokens.viewport.small)]: {
                        gridRow: '1',
                        gridColumn: '2'
                    }
                })
            ]
        },
        description: {
            uses: [
                css({
                    [media.up(tokens.viewport.small)]: {
                        gridColumn: '1',
                        alignSelf: 'start'
                    },
                    lineHeight: '1.5'
                })
            ]
        },
        error: {
            uses: [
                css({
                    column: '2/1',
                    [media.up(tokens.viewport.small)]: {
                        marginTop: `${tokens.space.small}`,
                        gridArea: '2/2'
                    }
                })
            ]
        }
    }
});

//# sourceMappingURL=textField.js.map